define([
	"dojo/_base/declare",
	"csi/comm/Aspera",
	"csi/html",
	"./ToolbarPluginButton"
], function (declare, Aspera, html, ToolbarPluginButton) {

	return declare(ToolbarPluginButton, {
		/** @property {boolean} multiple - if true, then multiple files can be selected */
		multiple: true,

		/**
		 * @override
		 * Open file browser and wait for 
		 */
		onClick: function () {
			if (Aspera.isEnabled()) {
				this.onChange();
			} else {
				const dfd = this.multiple ? html.selectFiles() : html.selectFile();
				dfd.then((files) => {
					this.onChange(files);
				});
			}
		},

		validatePlugin: function (/*Context*/ctx) {
			// summary: action not valid when read-only or printing
			return !ctx.bPrint && !ctx.isReadOnly();
		}
	});
});